export const setModalData = 'SET_MODAL_DATA';
export const resetModalData = 'RESET_MODAL_DATA';
